'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class projectModel extends ngDepModel
{

	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}

	afterSetup(data){
		if(typeof(this.late_payment_interest) !== 'undefined' && !isNaN(this.late_payment_interest)){
			this.late_payment_interest = Number(parseFloat(this.late_payment_interest).toFixed(2));
		}
		else{
			this.late_payment_interest = Number(0.00);
		}
		this.in_euros = (this.in_euros == 1 || this.in_euros === true);
		this.liability_for_recoveries = (this.liability_for_recoveries == 1 || this.liability_for_recoveries === true);
	}


	getValue(name){
		switch(name){
			case 'created':
			case 'updated':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name], 'dd/MM/y HH:mm (Z)');
			case 'starting_date_date':
			case 'end_date_date':
				if(this[name] == 0){
					return '';
				}
				return this.s('$filter')('u2date')(this[name]);
			case 'status':
				return this.getClassifValue(name, 'project_status');
			case 'application_status':
				return this.getClassifValue(name, 'application_status');
			case 'coordinator_country_id':
				return this.getClassifValue(name, 'country');
			case 'in_euros':
				return this.getClassifValue(name, 'yesno');
			case 'requested_amount':
			case 'maximum_amount':
				return this.s('$filter')('currency')(this[name]);
			case 'payment_ceiling':
				const val = this.getClassifValue('prefinancing_ceiling_id', 'ceiling');
				if(val === ''){
					val = '0';
				}
				return this.s('$filter')('tr')('prefinancing_ceiling_tpl').replace(/\{pc\}/, val);
			case 'late_payment_interest':
				return this.s('$filter')('tr')('late_payment_interest_tpl').replace(/\{val\}/, this[name]);
			case 'liability_for_enforced_recoveries':
				return this.getClassifValue(name, 'liability_enrec');
		}
		if(typeof(this[name]) !== 'undefined' && this[name] !== ''){
			return this[name];
		}
		return null;
	}

}